import axios from 'axios'
import store from '@/framework/store'
import { baseUrl } from '@danckuts/api-js'

const HTTP = axios.create({
  baseURL: baseUrl('8080', 'atlas')
})

HTTP.interceptors.request.use(request => {
  // if not logging in (via 'token') then apply
  // base '/api' url
  if (!request.url.endsWith('/token')) {
    request.baseURL = `${request.baseURL}/api`
  }

  // if access token exists then send it with each request
  let accessToken = store.getters['user/getAccessToken']
  if (accessToken) {
    request.headers.Authorization = `bearer ${accessToken}`
  }
  return request
})

HTTP.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    store.dispatch('user/logout')
    // redirect after logout
    return Promise.reject(error)
  }
  return Promise.reject(error)
})

export default HTTP
